import script from "./GameOverlayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GameOverlayModal.vue?vue&type=script&setup=true&lang=js"

import "./GameOverlayModal.vue?vue&type=style&index=0&id=180e8ca8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180e8ca8"]])

export default __exports__